export const OUTPUT_TYPE_SELECT_ALL_VALUE = '__all_output_types__';

export const getOutputTypeValue = (item) => {
  if (item && typeof item === 'object') {
    return item.output_type_id ?? item.value ?? item.id;
  }

  return item;
};

export const normalizeOutputTypeSelection = (selection = []) => {
  const values = Array.isArray(selection) ? selection : [selection];
  const seen = new Set();

  return values.reduce((result, item) => {
    const value = getOutputTypeValue(item);
    if (value === null || value === undefined || value === '') return result;

    const key = String(value);
    if (seen.has(key)) return result;

    seen.add(key);
    result.push(value);
    return result;
  }, []);
};

export const getOutputTypeSelectionState = (selection = []) => {
  const outputTypeIds = normalizeOutputTypeSelection(selection);

  return {
    outputTypeIds,
    primaryOutputTypeId: outputTypeIds[0] ?? null,
    isManyOutputs: outputTypeIds.length > 1,
  };
};

export const getSelectedOutputTypeOptions = (options = [], selection = []) => {
  const selectedIds = new Set(normalizeOutputTypeSelection(selection).map(String));

  return (Array.isArray(options) ? options : []).filter((option) =>
    selectedIds.has(String(getOutputTypeValue(option))),
  );
};

export const resolveOutputTypeSelection = (selection = [], options = [], currentSelection = []) => {
  const realOptions = (Array.isArray(options) ? options : []).filter(
    (option) => String(getOutputTypeValue(option)) !== OUTPUT_TYPE_SELECT_ALL_VALUE,
  );
  const realOptionById = new Map(
    realOptions.map((option) => [String(getOutputTypeValue(option)), option]),
  );
  const requestedValues = normalizeOutputTypeSelection(selection);
  const requestedSelectAll = requestedValues.some(
    (value) => String(value) === OUTPUT_TYPE_SELECT_ALL_VALUE,
  );
  const currentIds = new Set(
    normalizeOutputTypeSelection(currentSelection)
      .filter((value) => String(value) !== OUTPUT_TYPE_SELECT_ALL_VALUE)
      .map(String),
  );
  const isCurrentlyAllSelected =
    realOptions.length > 0 &&
    realOptions.every((option) => currentIds.has(String(getOutputTypeValue(option))));

  let selectedOptions;
  if (requestedSelectAll) {
    selectedOptions = isCurrentlyAllSelected ? [] : realOptions;
  } else {
    const seen = new Set();
    selectedOptions = requestedValues.reduce((result, value) => {
      const key = String(value);
      const option = realOptionById.get(key);
      if (!option || seen.has(key)) return result;

      seen.add(key);
      result.push(option);
      return result;
    }, []);
  }

  return {
    selectedOptions,
    ...getOutputTypeSelectionState(selectedOptions),
  };
};
